import InputDateTime from "../../../../components/input/input-datetime.jsx";
import MapPointInput from "../../../../components/reports/map-point-input/map-point-input.jsx";
import {useQuery} from "@tanstack/react-query";
import CorporationService from "../../../../services/web/corporation-service.js";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const {
        leadersIdentification,
        allowedOnly,
        allTeams,
        allVehicles,
    } = useReportFiltersFetch({
        fetchLeadersIdentification: true,
        fetchAllowedOnly: true,
        fetchAllTeams: true,
        fetchAllVehicles: true,
    });

    const { data: corporation } = useQuery({
        queryKey: ['corporation'],
        queryFn: () => CorporationService.entity(),
    });

    const teamOptions = [
        {  value: "WITHOUT-TEAM", label: "Não informado" },
        ...allTeams,
    ];

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                />
                <MapPointInput
                    corporation={corporation}
                    latLng={filters.latLng}
                    range={filters.range}
                    onChangeLatLng={(value) => setFilters(prev => ({ ...prev, latLng: value }))}
                    onChangeRange={(value) => setFilters(prev => ({ ...prev, range: value }))}
                />
                <SelectComponent
                    id="leader"
                    label="Responsável"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={leadersIdentification}
                    value={filters.leader}
                    onChange={(value) => setFilters(prev => ({ ...prev, leader: value }))}
                />
                <SelectComponent
                    id="guard"
                    label="Contingentes"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={allowedOnly}
                    value={filters.guard}
                    onChange={(value) => setFilters(prev => ({ ...prev, guard: value }))}
                    showSelectAll={false}
                />
                <SelectComponent
                    id="team"
                    label="Equipe"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={teamOptions}
                    value={filters.team}
                    onChange={(value) => setFilters(prev => ({ ...prev, team: value }))}
                    showSelectAll={false}
                />
                <SelectComponent
                    id="vehicle"
                    label="Veículo"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={allVehicles}
                    value={filters.vehicle}
                    onChange={(value) => setFilters(prev => ({ ...prev, vehicle: value }))}
                    showSelectAll={false}
                />
            </form>
        </div>
    )
}